module.exports = __webpack_public_path__ + "media/packs/images/state/sea-a3f29b7b59002435d564e78c0a89e795.svg";